<template>
  <div class="container_box details_box_styles">
    <!--返回按钮-->
    <div class="go_back" @click="goBackBtn">
      <Icon class="back_icon" type="ios-arrow-back"/>
      <span class="back_txt">{{ $t('key1002627') }}</span>
    </div>
    <!--拣货单详情-->
    <div class="basic_information_box">
      <Card :bordered="false" dis-hover>
        <template #title><h2 class="title_box">{{ $t('key1004975') }}</h2></template>
        <Row type="flex" :gutter="gutterItem">
          <Col :span="ItemCol" class="basic_item">
            <span class="basic_title">{{ $t('key1004706') }}</span>
            <span class="basic_txt">{{ detailInfo.pickingGoodsNo }}</span>
          </Col>
          <Col :span="ItemCol" class="basic_item">
            <span class="basic_title">{{ $t('key1000207') }}</span>
            <span class="basic_txt">{{ detailInfo.packageGoodsType }}</span>
          </Col>
          <Col :span="ItemCol" class="basic_item">
            <span class="basic_title">{{ $t('key1004704') }}</span>
            <span class="basic_txt">{{ detailInfo.packageGoodsStatus }}</span>
          </Col>
          <Col :span="ItemCol" class="basic_item">
            <span class="basic_title">{{ $t('key1004976') }}</span>
            <span class="basic_txt">{{ detailInfo.print }}</span>
          </Col>
          <Col :span="ItemCol" class="basic_item" v-if="where !== 'ymsPick'">
            <span class="basic_title">{{ $t('key1004770') }}</span>
            <span class="basic_txt">{{ detailInfo.remark }}</span>
          </Col>
          <Col :span="ItemCol" class="basic_item">
            <span class="basic_title color_style" @click="printList"
              v-if="getPermission('ymsPickingOrder_pickingOrderGoodsDetailList')">{{ $t('key1004755') }}</span>
          </Col>
          <Col :span="ItemCol" class="basic_item">
            <span class="basic_title">{{ $t('key1000205') }}</span>
            <span class="basic_txt">{{ detailInfo.warehouseName }}</span>
          </Col>
          <Col :span="ItemCol" class="basic_item">
            <span class="basic_title">{{ $t('key1001180') }}</span>
            <span class="basic_txt">{{ detailInfo.createdTime }}</span>
          </Col>
          <Col :span="ItemCol" class="basic_item">
            <span class="basic_title">{{ $t('key1004977') }}</span>
            <span class="basic_txt">{{ detailInfo.createdBy }}</span>
          </Col>
          <Col :span="ItemCol" class="basic_item" v-if="where !== 'ymsPick'">
            <span class="basic_title">{{ $t('key1004387') }}</span>
            <span class="basic_txt">{{ detailInfo.labelTypeText }}</span>
          </Col>
        </Row>
      </Card>
    </div>
    <!--功能按钮操作区域-->
    <div class="operation_box">
      <div class="mr15 sort_options_box">
        <Button-group style="margin-right: 10px">
          <Button
            :type="item.check ? 'primary' : 'default'"
            v-for="item in watchTypeData"
            @click="clickTypeButton(item)"
            :key="item.value">{{ item.label }}
          </Button>
        </Button-group>
      </div>
      <div v-if="formItem.type === '0'">
        <Input v-model.trim="formItem.sku" style="width: 300px" :placeholder="$t('key1004974')" clearable></Input>
        <Button type="primary" @click="btnSearch" class="ml15">{{ $t('key1000361') }}</Button>
      </div>
    </div>
    <!--列表-->
    <Table highlight-row border :columns="columns" :data="data" max-height="500"></Table>
    <!--确认删除最后一条-->
    <Modal v-model="dltLast" :title="$t('key1004299')" @on-ok="dltLastOk" @on-cancel="dltLastCancel">
      <p style="font-size: 14px;font-weight: 600">{{ $t('key1004978') }}</p>
    </Modal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import {
  getAllUsersInfo, getAllYmsWarehouseData, getDataSetBatchList, getUserNameByUserId,
  getWarehouseManageInfo, getWarehouseName, getEnumName
} from "@/utils/common";

export default {
  name: "pickListDetails",
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      ItemCol: 8,
      originalData: [],
      tableItemTotal: 0,
      dltLast: false,
      ymsPickingOrderId: '',
      detailInfo: {
        pickingGoodsNo: '',
        packageGoodsStatus: '',
        packageGoodsType: '',
        print: '',
        warehouseName: '',
        createdTime: '',
        createdBy: '',
        remark: '',
        labelTypeText: ''
      },
      formItem: {
        type: '0',
        sku: null,
        pageNum: 1,
        pageSize: 10
      },
      watchTypeData: [
        {label: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004965'), value: '0', check: true},
        {label: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004966'), value: '1', check: false}
      ],
      columns: [],
      data: [],
      columnsStockOut: [
        {
          type: 'index',
          width: 60,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001248'),
          key: 'packageCode',
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004371'),
          align: 'center',
          key: 'type',
          render(h, params) {
            let status = params.row?.ymsPackageInfo?.status;
            let text = getEnumName(this.enumData, 'YmsPackageInfoStatusCoreEnum', status);
            return h('span', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004967'),
          align: 'center',
          key: 'packageUploadCarrierStatus',
          render: (h, params) => {
            if (!params.row.ymsPackageInfo.labelPath) {
              return h('div', {
                style: {
                  color: '#FF0000'
                }
              }, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004968'));
            } else {
              return h('div', {
                style: {
                  color: '#008000'
                }
              }, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004969'));
            }
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000328'),
          align: 'center',
          key: 'ymsWarehouseId',
          render(h, params) {
            return h('span', getWarehouseName(v.warehouseList, params.row.ymsPackageInfo.ymsWarehouseId));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          align: 'center',
          key: 'address',
          width: 150,
          render: (h, params) => {
            return h('optsButtonList', {
              props: {
                operationList: [
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004970'),
                    show: params.row.packageGoodsRelationStatus !== '3' && v.getPermission('ymsPickingOrderRelated_delete'),
                    clickFn: () => {
                      v.axios.delete(api.delete_ymsPickingOrderRelated + params.row.ymsPickingOrderRelatedId).then(res => {
                        if (res.data.code === 0) {
                          v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000097'));
                          v.getDetail(this.ymsPickingOrderId);
                        }
                      });
                    }
                  }
                ]
              },
              on: {
                setWidth(value) {
                  if (value) {
                    v.optionBtnWidth.push(value);
                    params.column.width = Math.max(...v.optionBtnWidth);
                    v.$forceUpdate();
                  }
                }
              }
            });
          }
        }
      ],
      columnsGoods: [
        {
          type: 'index',
          width: 60,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004780'),
          key: 'warehouseName'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000213'),
          key: 'warehouseBlockName'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000214'),
          key: 'warehouseLocalName'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004551'),
          key: 'goodsUrl',
          render: (h, params) => {
            if (params.row._productInfo) {
              let skuImgPath = params.row._productInfo.primaryImage;
              let spuImgPath = params.row._productInfo._spuInfo.primaryImage
              let imgPath = skuImgPath ? skuImgPath : spuImgPath;
              return v.tableImg(h, params, null, imgPath);
            }
          }
        },
        {
          title: 'SKU',
          render(h, params) {
            return h('p', params.row._productInfo.ymsSku);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000216'),
          render(h, params) {
            return h('p', params.row._productInfo._spuInfo.name);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004971'),
          key: 'pickedQuantity'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004972'),
          key: 'goodsVolume',
          render(h, params) {
            let data = params.row._productInfo;
            if (params.row._productInfo) {
              return h('p', data.length + '*' + data.width + '*' + data.height);
            }
          }
        }, {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000854') + '(g)',
          key: 'goodsWeight',
          render(h, params) {
            return h('p', params.row._productInfo.weight);
          }
        }
      ],
      StockOutData: [],
      GoodsData: [],
      warehouseList: [],
      pickingGoodsNo: null,
      pickingStatus: null,
      where: 'sell',
      userInfoList: {},
      enumData: [],
    };
  },
  created() {
    let data = this.$route.query;
    if (data) {
      this.where = data.where;
      this.pickingStatus = data.pickingStatus;
      this.pickingGoodsNo = data.pickingGoodsNo;
      this.ymsPickingOrderId = data.ymsPickingOrderId;
    }
    if (this.where === 'ymsPick') {
      (async () => {
        let enumKeyList = [
          'YmsPickingOrderPackageGoodsTypeCoreEnum',
          'YmsPackageInfoStatusCoreEnum',
          'YmsPickingOrderStatusCoreEnum',
          'YmsPickupOrderLabelTypeCoreEnum'
        ];
        this.enumData = await getDataSetBatchList(enumKeyList);
        await getAllUsersInfo().then((data) => {
          this.userInfoList = data;
        });
        this.warehouseList = await getAllYmsWarehouseData();
        this.getDetail(this.ymsPickingOrderId);
      })();
    }
    if (this.pickingGoodsNo) {
      this.searchDtl(data => {
        this.StockOutData = data;
        this.data = this.StockOutData; // 出库单数据
      });
    }
    if (this.pickingStatus === '1') {
      this.columnsStockOut.pop();
    }
    if (this.where === 'other') {
      this.columnsStockOut.splice(4, 1);
    }
    this.columns = this.columnsStockOut; // 出库单表头
  },
  methods: {
    fixDataToView(response) {
      let datas = response;
      datas.pickingGoodsNo = datas.code;
      datas.packageGoodsType = getEnumName(this.enumData, 'YmsPickingOrderPackageGoodsTypeCoreEnum', datas.packageGoodsType);
      // 1:待拣货，2:拣货中，3:待分拣 4:分拣中 5:待包装 6:包装中 7:包装完成   8已取消
      datas.packageGoodsStatus = getEnumName(this.enumData, 'YmsPickingOrderStatusCoreEnum', datas.status);
      datas.print = datas.printedTime ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000392') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000393');
      datas.warehouseName = getWarehouseName(this.warehouseList, datas.ymsWarehouseId);
      datas.createdTime = this.$uDate.getDataToLocalTime(datas.createdTime, 'fulltime');
      datas.createdBy = getUserNameByUserId(datas.createdBy, this.userInfoList);
      return datas;
    },
    getDetail(id) {
      let v = this;
      if (v.getPermission('ymsPickingOrder_getPackageInfoList')) {
        let apiUrl = this.formItem.type === '1' ? api.get_ymsPickingOrder_pickingOrderGoodsList : api.get_ymsPickingOrder_getPackageInfoList;
        this.data = [];
        v.axios.get(apiUrl + id).then(response => {
          if (response.data.code === 0) {
            let datas = response.data.datas;
            this.detailInfo = v.fixDataToView(datas);
            if (this.formItem.type === '1') {
              (async () => {
                let ymsData = await v.getProductInfoByIds(datas.ymsPickingOrderDetails.map(i => i.ymsProductGoodsId), datas.ymsPickingOrderDetails);
                this.data = await getWarehouseManageInfo(datas.ymsPickingOrderDetails.map(i => i.ymsWarehouseLocationId), ymsData);
                this.originalData = JSON.parse(JSON.stringify(this.data));
              })();
            } else if (this.formItem.type === '0') {
              this.data = datas.ymsPickingOrderRelatedList;
              this.originalData = JSON.parse(JSON.stringify(this.data));
            }

          }
        });
      } else {
        v.gotoError();
      }
    },
    // 返回列表
    goBackBtn() {
      this.$router.push('/wms/pickList');
    },
    clickTypeButton(data) {
      // 按分配切换不同的表格
      this.formItem.pageNum = 1;
      this.watchTypeData.forEach(function (n) {
        n.check = data.value === n.value;
      });
      this.formItem.type = data.value;
      if (data.value === '1') {
        this.columns = this.columnsGoods;
      } else {
        this.columns = this.columnsStockOut;
      }
      this.getDetail(this.ymsPickingOrderId);
    },
    backList() {
      this.$parent.workShow = 'list';
    },
    paramsObj() {
      return {
        pickingGoodsNo: this.pickingGoodsNo,
        status: this.formItem.type,
        pickingNo: this.formItem.sku ? this.formItem.sku : null,
        pageNum: this.formItem.pageNum,
        pageSize: this.formItem.pageSize
      };
    },
    searchOfStockOut() {
      // 按出库单查找
      this.searchDtl(data => {
        this.StockOutData = data;
        this.GoodsData = [];
        this.data = this.StockOutData; // 出库单数据
      });
    },
    searchOfGood() {
      // 按商品查
      this.searchDtl(data => {
        this.GoodsData = data;
        this.StockOutData = [];
        this.data = this.GoodsData; // 商品数据
      });
    },
    btnSearch() {
      if (this.formItem.sku) {
        this.data = this.originalData.filter(i => i.packageCode === this.formItem.sku);
      } else {
        this.data = this.originalData;
      }
    },
    searchDtl(callback) {
      let obj = this.paramsObj();
      let v = this;
      this.axios.post(api.get_ymsPickingOrder_getPackageInfoList, obj).then(res => {
        if (res.data.code === 0) {
          let data = res.data.datas[0];
          this.detailInfo.pickingGoodsNo = data.pickingGoodsNo;
          this.detailInfo.remark = data.remark;
          this.detailInfo.packageGoodsStatus = data.packageGoodsStatus === '1' ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004412') : data.packageGoodsStatus === '0' ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004973') : '';
          this.detailInfo.packageGoodsType = data.packageGoodsType === 'SS' ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000203') : data.packageGoodsType === 'SM' ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000203')
            : data.packageGoodsType === 'MM' ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000202') : '';
          this.detailInfo.print = data.print === '0' ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000393') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000392');
          this.detailInfo.warehouseName = data.warehouseName;
          this.detailInfo.createdTime = this.$uDate.getDataToLocalTime(data.createdTime, 'fulltime');
          this.detailInfo.createdBy = data.createdByName;
          this.detailInfo.labelTypeText = getEnumName(v.enumData, 'YmsPickupOrderLabelTypeCoreEnum', data.labelType);
          if (this.formItem.type === '0') {
            this.tableItemTotal = res.data.datas[0].queryByPickingResultPage.total;
            callback && callback(res.data.datas[0].queryByPickingResultPage.list);
          } else {
            this.tableItemTotal = res.data.datas[0].queryByGoodsDetailResultPage.total;
            callback && callback(res.data.datas[0].queryByGoodsDetailResultPage.list);
          }
        }
      });
    },
    dltLastOk() {
      let obj = this.StockOutData[0];
      this.axios.post(api.post_wmsPickingGoods_modifyPickingByNo + '?pickingNo=' +
        obj.pickingNo + '&pickingGoodsNo=' + this.detailInfo.pickingGoodsNo).then(res => {
        if (res.data.code === 0) {
          this.StockOutData.splice(0, 1);
          this.$parent.workShow = 'list';
        }
      });
    },
    dltLastCancel() {
    },
    printList() {
      let goto = this.$router.resolve({
        path: '/printPickListBatch',
        query: {
          data: this.ymsPickingOrderId,
          type: 'pickList',
          where: this.where || null
        }
      });
      window.open(goto.href, '_blank');
    }
  },
};
</script>

<style lang="less" scoped>
.details_box_styles {
  .color_style {
    color: #2D8CF0;
    font-weight: bold;
    cursor: pointer;
  }
}
</style>
